import React from "react";
import { H2, P } from "../../styles";
import Button from "../../components/Button/Button";
import { useTranslation } from "react-i18next";
import NvidiaContainer from "../../hoc/NvidiaContainer";
import { ButtonsContainer } from "../../components/Button/styles";
import { deleteCookie } from "../../utils/helpers";

const Security = ({ email, locale, clearStorage, idToken }) => {
  const { t } = useTranslation();
  const navigateToSecurity = () => {
    location.href = `${
      locale === "zh-cn" ? JARVIS_SECURITY_CN : JARVIS_SECURITY
    }?login_hint=${encodeURIComponent(email)}`;
  };

  return (
    <NvidiaContainer>
      <H2>{t("Security")}</H2>
      <P>
        {t(
          "Change your password, see devices using your account, or change other security settings"
        )}
      </P>

      <ButtonsContainer>
        <Button label={t("Update")} clickHandler={navigateToSecurity} />
        <Button
          label={t("Logout")}
          clickHandler={() => {
            clearStorage();
            deleteCookie(LOGIN_HINTS_ITEM_NAME);
            const searchParams = new URLSearchParams({
              id_token_hint: idToken,
              post_logout_redirect_uri: location.href,
            });

            window.location.href = `${
              locale === "zh-cn" ? LOGOUT_URL_CN : LOGOUT_URL
            }?${searchParams.toString()}`;
          }}
          theme="alt"
        />
      </ButtonsContainer>
    </NvidiaContainer>
  );
};
export default Security;
